import Vue from "vue";

import RedemptionCentral from "./RedemptionCentral.vue";

export function load() {
    const selector = "redemption-central";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(RedemptionCentral, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
